<div *ngIf="pregunta && campoProductoVC?.visible" [formGroup]="form">
    <div *ngIf="pregunta.tipoRespuesta === '1' || pregunta.tipoRespuesta === '2'">
        <ca-form-field>
            <ca-label>{{pregunta.descPregunta}}</ca-label>
            <ca-select 
                [options]="preguntaCatalogo.respuestas" 
                keyValue="descRespuesta" 
                valueField="idRespuesta"
                [formControlName]="codCampo" 
                (change)="seleccionaRespuesta(pregunta)"
                [virtualScroll]="true"></ca-select>
            <ca-error *ngIf="form.controls[codCampo].errors?.required">
                {{'ERROR.ERROR_CAMPO_REQUERIDO' | translate}}</ca-error>
        </ca-form-field>
    </div>
    <div *ngIf="pregunta.tipoRespuesta === '3' || pregunta.tipoRespuesta === '4'">
        <ca-form-field>
            <ca-label>{{pregunta.descPregunta}}</ca-label>
            <input 
                caInput 
                (change)="cambiarRespuesta(pregunta, $event)" 
                [formControlName]="codCampo"                
                [value]="campoProductoVC?.valorDefecto" 
                type="number" />
            <ca-error *ngIf="form.controls[codCampo].errors?.required">
                {{'ERROR.ERROR_CAMPO_REQUERIDO' | translate}}</ca-error>
        </ca-form-field>
    </div>
    <div *ngIf="pregunta.tipoRespuesta === '5'">
        <ca-form-field>
            <ca-label>{{pregunta.descPregunta}}</ca-label>
            <ca-datepicker [formControlName]="codCampo"></ca-datepicker>
        </ca-form-field>
        <ca-error *ngIf="form.controls[codCampo].errors?.required">
            {{'ERROR.ERROR_CAMPO_REQUERIDO' | translate}}</ca-error>
    </div>
    <div *ngIf="pregunta.tipoRespuesta !== '1' 
    && pregunta.tipoRespuesta !=='2'
    && pregunta.tipoRespuesta !=='3'
    && pregunta.tipoRespuesta !=='4'
    && pregunta.tipoRespuesta !=='5'">
        <ca-form-field>
            <ca-label>{{pregunta.descPregunta}}</ca-label>
            <input 
                caInput 
                (change)="cambiarRespuesta(pregunta, $event)" 
                [formControlName]="codCampo"
                [value]="pregunta.descRespuesta" 
                type="text" />
            <ca-error *ngIf="form.controls[codCampo].errors?.required">
                {{'ERROR.ERROR_CAMPO_REQUERIDO' | translate}}</ca-error>
        </ca-form-field>

    </div>
</div>